import React, { useState, useEffect } from 'react';

const API_BASE = process.env.REACT_APP_API_URL || 'https://quotebid-backend-production.up.railway.app';

interface CapData {
  spotsRemaining: number;
  maxAllowed: number;
  currentCount: number;
  isFull: boolean;
}

interface SpotBadgeProps {
  city: string;
  category: string;
  tier: 'starter' | 'pro' | 'premium';
}

export const SpotBadge: React.FC<SpotBadgeProps> = ({ city, category, tier }) => {
  const [cap, setCap] = useState<CapData | null>(null);

  useEffect(() => {
    if (!city || !category) return;
    fetch(`${API_BASE}/api/reputation/caps?city=${encodeURIComponent(city)}&category=${encodeURIComponent(category)}`)
      .then(r => r.json())
      .then(data => setCap(data.caps?.[tier] || null))
      .catch(() => {});
  }, [city, category, tier]);

  if (!cap) return null;

  const pct = cap.currentCount / cap.maxAllowed;
  const isCritical = cap.spotsRemaining <= 1 || cap.isFull;
  const isWarning = cap.spotsRemaining <= Math.ceil(cap.maxAllowed * 0.25);

  return (
    <div style={{ marginTop: '8px' }}>
      <div style={{ height: '4px', background: '#e2e8f0', borderRadius: '2px', marginBottom: '4px' }}>
        <div style={{
          height: '100%', borderRadius: '2px',
          width: `${Math.min(pct * 100, 100)}%`,
          background: isCritical ? '#ef4444' : isWarning ? '#f59e0b' : '#10b981',
          transition: 'width 0.5s ease'
        }} />
      </div>
      <div style={{ fontSize: '11px', fontWeight: 700, color: isCritical ? '#ef4444' : isWarning ? '#f59e0b' : '#64748b' }}>
        {cap.isFull ? `⛔ Full in ${city} — waitlist only`
          : cap.spotsRemaining === 1 ? `🔴 Last spot in ${city}!`
          : isWarning ? `⚠️ Only ${cap.spotsRemaining} spots left in ${city}`
          : `${cap.spotsRemaining} of ${cap.maxAllowed} spots open in ${city}`}
      </div>
    </div>
  );
};

export default SpotBadge;